//
//
//
//
//
//
//
//

import { setTitle } from '@/assets/js/util'
import Vue from "vue";
export default {
  name: 'App',
  data() {
		return {
		  hasPadding:true,
      showReceiveCount:false,
      name:"",
      exclude: [
        'foundationPay',
         'certApply',
         'certificate',
        'payZfb',
        'monthRturn'
      ]
    }
  },
  created(){
    if(window.history.length<=1){
      this.pushHistory()
    };
  },
  mounted() {
    let colors= {
      'shanxing':{
        color:'#2B5CC4',
        btn:'#EEF3FF',
        month:'#FC6433',
      },
      'smile':{
        color:'#43b9ac',
        btn:'#DFFFFB',
        month:'#FF8C19',
      },
      'scredcross':{
        color:'#FF565B',
        btn:'#FFF6F6',
        month:'#5681FF',
      },
      'zjfdp':{
        color:'#F96654',
        btn:'#FFEAE8',
        month:'#5681FF',
      },
      'bee':{
        color:'#3DA778',
        btn:'#E9FFF5',
        month:'#FC6433',
      }
    }
    document.documentElement.style.setProperty('--theme-color',colors[this.project].color)
    document.documentElement.style.setProperty('--month-bgcolor',colors[this.project].month)
    document.documentElement.style.setProperty('--btn-bgcolor',colors[this.project].btn)

    this.$nextTick(() => {
			window.toast = this.$vux.toast;
      window.confirm = this.$vux.confirm;
    })
  },
  methods:{
    pushHistory() {
      let state1 = {
        title: "title",
        url: "#"
      };
      window.history.pushState(state1, "title", "#");
    },

  },
  computed: {
	},
  watch:{
    $route( to , from ){
      if(to.meta.title)
        setTitle(to.meta.title)
    }
  }
}



// WEBPACK FOOTER //
// ./src/App.vue